function SleepQualityTracker() {
    return (
      <>
        <p>test3</p>
      </>
    );
  }
  
export default SleepQualityTracker;